import { Table } from "flowbite-react";
import { formatDocument } from "../../../utils/utils";

const ParticipacaoEmEmpresas = ({ empresas }) => {
  return (
    <>
      <div className="overflow-x-hidden border-gray-100 border rounded-lg mt-3">
        <Table striped>
          <Table.Head className="text-black">
            <Table.HeadCell
              className="text-center py-2 px-1"
              style={{ background: "#EBF5FF" }}
            >
              Nº
            </Table.HeadCell>
            <Table.HeadCell className="py-2" style={{ background: "#EBF5FF" }}>
              Empresa
            </Table.HeadCell>
            <Table.HeadCell
              className="text-center py-2 px-1"
              style={{ background: "#EBF5FF" }}
            >
              Data <br /> Entrada
            </Table.HeadCell>
            <Table.HeadCell
              className="text-center py-2 px-1"
              style={{ background: "#EBF5FF" }}
            >
              Função
            </Table.HeadCell>
            <Table.HeadCell
              className="text-center py-2 px-1"
              style={{ background: "#EBF5FF" }}
            >
              Part. (%)
            </Table.HeadCell>
          </Table.Head>
          {empresas?.length > 0 && (
            <Table.Body className="divide-y">
              {empresas?.map((empresa, index) => (
                <Table.Row
                  key={index}
                  className="bg-white dark:border-gray-700 dark:bg-gray-800 text-black"
                >
                  <Table.Cell className="font-medium dark:text-white text-center py-1 px-1">
                    {index + 1}
                  </Table.Cell>
                  <Table.Cell className=" py-1">
                    <div>{empresa?.empresa || "-"}</div>
                    <div className="text-blue-800" style={{ fontSize: "12px" }}>
                      CNPJ: {formatDocument(empresa?.cnpj)}
                    </div>
                  </Table.Cell>
                  <Table.Cell className="text-center py-1 px-1">
                    {empresa?.dataEntrada || "-"}
                  </Table.Cell>
                  <Table.Cell className="text-center py-1 px-1">
                    {empresa?.funcao || "-"}
                  </Table.Cell>
                  <Table.Cell className="text-center py-1 px-1 px-1">
                    {empresa?.participacaoEmPorcentagem ||
                      empresa?.percentualParticipacao ||
                      "-"}
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          )}
        </Table>
      </div>
    </>
  );
};

export default ParticipacaoEmEmpresas;
